'use client';
import Link from '@/components/ui/Link';

interface CategoryProps {
    image: string;
    title: string;
    href: string;
}

const CategoryCard = ({ image, title, href }: CategoryProps) => (
    <Link href={href} className="group" ariaLabel={title}>
        <div className="flex flex-col gap-2.5 sm:gap-3 w-full">
            <div className="relative overflow-hidden rounded-xl sm:rounded-2xl">
                <img
                    src={image}
                    alt={title}
                    loading="lazy"
                    decoding="async"
                    className="w-full h-[220px] sm:h-[280px] lg:h-[360px] object-cover transition-transform duration-300 group-hover:scale-105"
                />
            </div>
            <h3 className="text-lg sm:text-xl lg:text-2xl text-text-primary font-semibold leading-tight text-center group-hover:text-primary-brand transition-colors">
                {title}
            </h3>
        </div>
    </Link>
)

export default function CategoriesSection() {
    const categories: CategoryProps[] = [
        {
            image: '/images/img_rectangle_7.webp',
            title: 'Men',
            href: '/categories'
        },
        {
            image: '/images/img_rectangle_8.webp',
            title: 'Women',
            href: '/categories'
        },
        {
            image: '/images/img_rectangle_9.webp',
            title: 'Kids',
            href: '/categories'
        },
        {
            image: '/images/img_rectangle_10.webp',
            title: 'Shoes',
            href: '/categories'
        },
        {
            image: '/images/img_rectangle_11.webp',
            title: 'Bags',
            href: '/categories'
        }
    ]

    return (
        <section className="w-full py-10 sm:py-14 lg:py-20">
            <div className="w-full max-w-[1920px] mx-auto px-4 sm:px-6 lg:px-[60px]">
                <div className="w-full max-w-[1804px] mx-auto flex flex-col gap-6 sm:gap-8 lg:gap-[30px]">
                    {/* Section Header */}
                    <div className="flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4">
                        <h2 className="text-2xl sm:text-3xl lg:text-5xl text-text-primary font-semibold leading-tight">
                            Shop By Category
                        </h2>

                        <Link
                            href="/categories"
                            className="flex flex-row items-center gap-2 sm:gap-3 group"
                            ariaLabel="View all categories"
                        >
                            <span className="text-sm sm:text-base lg:text-lg text-text-subtle font-medium group-hover:text-primary-brand transition-colors duration-200">
                                View all categories
                            </span>
                            <img
                                src="/images/img_arrow_right_gray_600_01.svg"
                                alt=""
                                className="w-3.5 h-3.5 sm:w-4 sm:h-4 group-hover:translate-x-1 transition-transform duration-200"
                            />
                        </Link>
                    </div>

                    {/* Categories Grid */}
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 sm:gap-5 lg:gap-[24px]">
                        {categories.map((category, index) => (
                            <CategoryCard key={index} {...category} />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}